import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p>We are committed to protecting the privacy of our users. This Privacy Policy outlines how we collect, use, and protect the personal information of our users.</p>
      <p>We collect personal information such as name, email address, and phone number when users sign up for our services. This information is used to provide and improve our services, and to communicate with our users about their accounts and our services.</p>
      <p>We may also collect non-personal information such as browser type, operating system, and IP address for analytical purposes. This information is used to improve our services and to better understand how our users interact with our website.</p>
      <p>We will never sell or share our users' personal information with third parties without their consent, except as required by law or to fulfill our obligations to our users. We take reasonable measures to protect the security of our users' personal information and to prevent unauthorized access or disclosure.</p>
      <p>By using our services, users consent to the collection and use of their personal information as described in this Privacy Policy.</p>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at hello@videointro.co.</p>
    </div>
  );
};

export default PrivacyPolicy;
